import { useRef, FC } from "react";
import { motion, useInView } from "framer-motion";
import "./IllustratedCard.css";
import { LottieAnimation } from "@tennr/frontend/components/LottieAnimation";
import { DynamicText } from "@tennr/frontend/components/DynamicText";

// since we're having issues with the Lottie file format, let's create an animated
// illustration using framer-motion instead
type IllustratedCardProps = {
  body?: string;
  heading?: string;
  image?: string;
  lottiePath?: string;
};

export const IllustratedCard: FC<IllustratedCardProps> = ({
  body = "Run a unified processes from eligibility to complex benefits investigations that guarantees you get paid for the work you do. Catch missing info before billing gets involved.",
  heading = "Slash first-time denials by 98%",
  image = "/img/illustration-1.png",
  lottiePath,
}) => {
  const containerRef = useRef<HTMLDivElement>(null!);
  const inView = useInView(containerRef, { once: false, margin: "0px" });

  return (
    <div className="illustrated-card" ref={containerRef}>
      <motion.div
        className="illustration-container"
        // initial={{ opacity: 0, scale: 0.9 }}
        // animate={inView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.9 }}
        transition={{ duration: 0.6, delay: 0.5 }}
      >
        {lottiePath ? (
          <LottieAnimation src={lottiePath} width={315} loop={true} autoplay={true} className="feature-lottie" />
        ) : (
          <motion.img
            className="illustration"
            src={image}
            alt="Illustration"
            style={{
              width: "100%",
              height: "auto",
              display: "block",
            }}
            initial={{
              opacity: 0,
              mixBlendMode: "multiply",
            }}
            animate={
              inView
                ? {
                    opacity: 1,
                    mixBlendMode: "multiply",
                  }
                : {
                    opacity: 0,
                    mixBlendMode: "multiply",
                  }
            }
            transition={{
              opacity: { duration: 0.5, delay: 0.3 },
              mixBlendMode: { duration: 0.8, delay: 0.6 },
            }}
          />
        )}
      </motion.div>
      <DynamicText as="h3" className="illustrated-card-heading">
        {heading}
      </DynamicText>
      <DynamicText as="p" className="illustrated-card-body">
        {body}
      </DynamicText>
    </div>
  );
};
